import { Injectable } from '@angular/core';
import { firstValueFrom} from 'rxjs';
import { HttpService } from '../http/http.service';
import { UserPermission } from '../../interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private controller:string="/Permissions/";
  constructor(private _http: HttpService) {}

  public async getAll():Promise<UserPermission[]> {
    return firstValueFrom(this._http.get(this.controller));
  }
  public async getByUser(id: number): Promise<UserPermission[]> {
    return firstValueFrom(this._http.get(this.controller + id));
  }
  public updateByUser(userId: number, permissions: number[]): Promise<UserPermission[]> {
    return firstValueFrom(this._http.post(this.controller+ userId, permissions));
  }
}
